import { render, staticRenderFns } from "./freeMatches.vue?vue&type=template&id=78e4ef8b"
import script from "./freeMatches.vue?vue&type=script&lang=js"
export * from "./freeMatches.vue?vue&type=script&lang=js"
import style0 from "./freeMatches.vue?vue&type=style&index=0&id=78e4ef8b&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports